module.exports = __webpack_public_path__ + "img/weblink-l.a51cf941.svg";